module.exports = __webpack_public_path__ + "static/media/ETH3.32518e2a8e18641156aa999b8df00c91.svg";